{
  "storageMissing": "저장소 없이 뜬 서버다. 기동 발급이 돌지 않았다",
  "serverBusy": "서버가 몰린 요청을 처리하는 중입니다. 잠시 뒤 다시 누릅니다",
  "serverFailed": "서버가 처리하지 못한 오류가 났습니다. 같은 동작을 다시 해 보고, 그래도 안 되면 CT에게 알릴 것",
  "revokeHandleMissing": "접속을 끊을 수단 없이 뜬 서버다. 지우면 그 사람 화면이 살아남는다",
  "malformedBody": "입력 형식이 맞지 않습니다",
  "ctOnly": "room 관리 코드로 증명한 세션만 할 수 있다",
  "tooManyFailures": "이 연결에서 실패가 너무 많습니다. 잠시 뒤 다시 넣습니다",
  "roomNotOpened": "아직 CT가 이 room을 열지 않았습니다. CT 가 열면 다시 누릅니다",
  "notWhitelisted": "명단에 없는 게임 ID입니다. CT 에게 이 게임 ID 를 알려 등록을 받습니다",
  "ctNicknameEmpty": "CT 닉네임이 비어 있다",
  "nicknameEmpty": "닉네임이 비어 있다",
  "nicknameRequired": "닉네임을 넣어 주세요",
  "gameIdTaken": "이미 명부에 있는 게임 ID입니다: {value}. 이름은 목록에서 고칩니다",
  "allyNameTakenOnAdd": "아군 명부에 이미 있는 이름입니다: {value}. 다른 이름으로 올리거나, 이미 올라 있는 그 줄에서 고칩니다",
  "allyNameTakenOnRename": "아군 명부에 이미 있는 이름입니다: {value}. 다른 이름을 넣어 주세요",
  "enemyNameTaken": "적 명부에 이미 있는 이름입니다: {value}. 다른 이름을 넣어 주세요",
  "allyMissing": "그 아군이 명부에 없습니다",
  "allyInRally": "rally {value} 줄을 맡고 있어 지울 수 없습니다. 조립 중이면 그 줄을 빼고, 내보낸 뒤면 줄을 다른 사람에게 넘기거나 ops 를 접은 다음 지웁니다. 접속만 끊으려면 추방합니다",
  "enemyMissing": "그 적이 명부에 없습니다",
  "rosterMissing": "그 사람이 명부에 없습니다",
  "marchingNotInteger": "행군 시간은 정수 밀리초여야 합니다",
  "marchingNegative": "행군 시간은 음수일 수 없습니다",
  "marchingGrid": "행군 시간은 0.1초 단위까지만 받습니다",
  "marchingUnknown": "{value} 의 행군 시간이 아직 없습니다. 명부에서 먼저 넣습니다",
  "rallyMissing": "그 rally 가 시퀀스에 없습니다",
  "mainOnlyOne": "main 은 하나뿐입니다",
  "mainFirst": "main 을 먼저 만듭니다. 착탄 간격의 기준입니다",
  "mainOffsetZero": "main 의 착탄 간격은 0 입니다. main 이 착탄축의 원점입니다",
  "mainLockedBySub": "sub 가 남아 있어 main 을 지울 수 없습니다. sub 를 먼저 지웁니다",
  "mainRequired": "main 이 없으면 시퀀스가 성립하지 않습니다",
  "rallyingPositive": "rallying 은 0 보다 커야 합니다",
  "leadFloorHandle": "개시는 지금부터 6초 뒤보다 이를 수 없습니다. 넣은 값은 {value}초입니다",
  "leadFloorDerived": "이 조합은 개시가 {value}초 뒤라 붙일 수 없습니다. 개시는 지금부터 6초 뒤여야 하니 착탄 간격을 늘리거나 rallying 을 줄입니다",
  "alreadyConfirmed": "이미 조립을 마친 시퀀스입니다",
  "handleAfterConfirm": "time handle 은 조립을 마친 뒤에만 놓습니다",
  "handleFirst": "time handle 을 먼저 놓습니다",
  "dispatchNeedsConfirm": "조립을 마친 시퀀스만 confirm 할 수 있습니다",
  "dispatchEmpty": "빈 시퀀스는 confirm 할 수 없습니다",
  "dispatchNeedsMain": "main 이 없는 시퀀스는 confirm 할 수 없습니다. main 이 착탄축의 원점입니다",
  "removeOnDispatched": "confirm 한 ops 에서는 줄을 뺄 수 없습니다. 「이 ops 수정」으로 편집에 돌아가면 뺄 수 있고, 「이 ops 접기」는 편성을 버립니다",
  "discardNeedsDispatched": "아직 confirm 하지 않은 ops 입니다. 줄을 빼는 것은 rally 편집기에서 합니다",
  "reopenNeedsDispatched": "아직 confirm 하지 않은 ops 입니다. 지금 이미 줄을 고치고 뺄 수 있습니다",
  "retimeNeedsDispatched": "아직 confirm 하지 않은 ops 입니다. 개시 시각은 time handle 로 놓습니다",
  "editNeedsDispatched": "아직 confirm 하지 않은 ops 입니다. 줄을 빼고 다시 적재하는 편집기가 있습니다",
  "retimeNoSequence": "다시 잡을 ops 가 없습니다",
  "remainingNegative": "남은 시간은 음수일 수 없습니다",
  "remainingGrid": "남은 시간은 0.1초 단위로 넣습니다",
  "enemyRallyMissing": "그 적 rally 가 없습니다",
  "networkUnreachable": "서버에 닿지 못했습니다. 주소와 연결을 확인합니다",
  "requestFailed": "요청이 실패했다 ({value})",
  "sessionRequired": "입장하지 않은 요청이다",
  "codeVaultUnreadable": "코드 금고 파일을 읽을 수 없다. 관리 코드는 저장소에 해시로만 있어 되돌릴 수 없다. ROTATE_ADMIN_CODE=<임의 문자열> 로 서버를 다시 띄워 재발급할 것",
  "joinCodeWrong": "입장 코드가 맞지 않습니다. CT 에게 지금 입장 코드를 다시 받습니다",
  "adminCodeWrong": "room 관리 코드가 맞지 않습니다. 코드가 재발급됐으면 재발급한 CT 에게 새 코드를 받습니다",
  "joinCodeIsAdminCode": "이건 room 관리 코드입니다 (16자). 입장 코드는 10자입니다. CT 라면 아래 「CT 입니까?」를 누릅니다",
  "joinCodeLength": "입장 코드는 10자입니다. 넣은 값은 {value}자입니다. CT 에게 받은 10자를 다시 넣습니다",
  "adminCodeIsJoinCode": "이건 공용 입장 코드입니다 (10자). room 관리 코드는 16자입니다. 연맹원이라면 아래 「입장 코드로 돌아가기」를 누릅니다",
  "adminCodeLength": "room 관리 코드는 16자입니다. 넣은 값은 {value}자입니다. 16자 관리 코드를 다시 넣습니다",
  "gameIdDigitsOnly": "게임 ID는 숫자만 넣습니다 (예: 131952426)",
  "gameIdTooLong": "게임 ID는 24자리까지입니다. 넣은 값은 {value}자리입니다",
  "marchingIntegerBody": "행군 시간은 정수 밀리초로 보냅니다 (모르면 비웁니다)",
  "pathOutsideRoot": "뿌리 밖의 경로입니다"
}
